import { ListItemIcon } from '@mui/material';

import Icon, { IconType } from '../../../mui-wrapper-components/Icon/Icon';

export type ActionMenuItemIconProps = {
  /**
   * @props {string} id - id of the menu item, used to create testid
   */
  id: string;

  /**
   * @props {boolean} disabled - disable the menu item
   * @default false
   */
  disabled?: boolean;

  /**
   * @props {string} icon - icon of the menu item
   */
  icon?: IconType | React.ReactNode;

  /**
   * @props {string} iconDisabled - icon of the menu item when disabled
   */
  iconDisabled?: IconType;
};

export const ActionMenuItemIcon = (props: ActionMenuItemIconProps) => {
  const { id, disabled = false, icon, iconDisabled } = props;

  if (disabled && iconDisabled) {
    return (
      <ListItemIcon sx={{ width: '40px' }}>
        <Icon id={`${id}-iconDisabled-${iconDisabled}`} icon={iconDisabled} />
      </ListItemIcon>
    );
  }

  if (typeof icon === 'string') {
    return (
      <ListItemIcon sx={{ width: '40px' }}>
        <Icon id={`${id}-icon-${icon}`} icon={icon as IconType} />
      </ListItemIcon>
    );
  } else {
    return <ListItemIcon sx={{ width: '40px' }}>{icon}</ListItemIcon>;
  }
};
